import React, { useContext, useEffect, useState } from "react";

import { Form } from "@/components/Form";
import { Typography } from "@/components/Typography";

import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues } from "@/utils/formHelper";
import { omittedValues } from "@/utils/qrEditorHelper";

import { qrSmsValidation } from "@/utils/validators/qr-sms";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QRSMSProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const QRSms = ({ data }: QRSMSProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = useContext<QREditorContextProps<"sms">>(QREditorContext);

  const [qrSMSData, setQrSMSData] = useState<QRProps<"sms">>(qrData);
  const [renderForm, setRenderForm] = useState(false);

  const dataSMSWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    setQrData({ ...qrData, data: { ...qrData.data, [field]: value } }, omittedValues(qrData.data));
  };

  useEffect(() => {
    setQrSMSData(qrData);
  }, [qrData]);

  useEffect(() => {
    setQrData({ ...qrSMSData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-sms">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataSMSWithDefaultValues}
        schema={qrSmsValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
